import { Schema } from "effect";
export class ContractDecodeError extends Schema.TaggedError<ContractDecodeError>()(
  "ContractDecodeError",
  { message: Schema.String, status: Schema.tag(400) }
) {}

const ApiValidationFields = /* @__PURE__ */ (() => Schema.Struct({ message: Schema.String, status: Schema.tag(400) }))();
type ApiValidationProperties = typeof ApiValidationFields["~type.make.in"];

export const WorktreeApiValidationError = /* @__PURE__ */ (() => {
  class WorktreeApiValidationError extends Schema.TaggedError<WorktreeApiValidationError>()("WorktreeApiValidationError", ApiValidationFields) {
    constructor(message: string | ApiValidationProperties, options?: Schema.MakeOptions) {
      super(typeof message === "string" ? { message } : message, options);
      this.name = "WorktreeApiValidationError";
    }
    toJSON() { return { status: this.status, name: this.name }; }
  }
  return WorktreeApiValidationError;
})();
export type WorktreeApiValidationError = InstanceType<typeof WorktreeApiValidationError>;

export const DevelopmentRunApiValidationError = /* @__PURE__ */ (() => {
  class DevelopmentRunApiValidationError extends Schema.TaggedError<DevelopmentRunApiValidationError>()("DevelopmentRunApiValidationError", ApiValidationFields) {
    constructor(message: string | ApiValidationProperties, options?: Schema.MakeOptions) {
      super(typeof message === "string" ? { message } : message, options);
      this.name = "DevelopmentRunApiValidationError";
    }
    toJSON() { return { status: this.status, name: this.name }; }
  }
  return DevelopmentRunApiValidationError;
})();
export type DevelopmentRunApiValidationError = InstanceType<typeof DevelopmentRunApiValidationError>;
